import { stopPropagation } from '../../../../../../utils/events'
import { EntityMultiValuedListMoreItem } from '../../../../../Entity'
import { useFloatingSelectContext } from '../../../../../Floating'
import { CopiedToMoreUserItem } from '../CopiedToMoreUserItem'
import { COPIED_TO_TAG_LIST_FUNCTION_BY_ENTITY } from '../CopiedToTagList.constants'
import { isCopyUserItem } from '../CopiedToTagList.utils'

import * as styles from './CopiedToTagMoreItem.module.css'

function CopiedToTagMoreItem({
  entity,
  id,
  role,
  onClick,
  onDelete,
  onMouseDown,
  ...restProps
}) {
  const { context } = useFloatingSelectContext()

  function handleClick(event) {
    onClick({ entity, event, id, role })
  }

  function handleClickUserItem(_value, event) {
    onClick({ entity, event, id, role })
  }

  function handleMouseDownUserItem(_value, event) {
    onMouseDown({ entity, event, id, role })
  }

  function handleDelete(event) {
    stopPropagation(event)

    context.setOpen(false)

    onDelete({
      event,
      getPreparedData: COPIED_TO_TAG_LIST_FUNCTION_BY_ENTITY[entity],
      id,
    })
  }

  return isCopyUserItem(entity) ? (
    <CopiedToMoreUserItem
      {...restProps}
      hoverClassName={styles.hover}
      id={id}
      role={role}
      onClick={handleClickUserItem}
      onDelete={handleDelete}
      onMouseDown={handleMouseDownUserItem}
    />
  ) : (
    // # TODO add components for other entities
    <EntityMultiValuedListMoreItem {...restProps} onClick={handleClick} />
  )
}

export default CopiedToTagMoreItem
